function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BaseCard, BaseCardBody, BaseCardHeader, Button, CheckBoxField } from '@unite-us/ui';

// Q. Do we need to handle "high risk" needs in the UI?
function ScreeningNeedSelector(_ref) {
  var initiallyChecked = _ref.initiallyChecked,
    isHighRisk = _ref.isHighRisk,
    needs = _ref.needs,
    onSubmit = _ref.onSubmit,
    isSupersetEnabled = _ref.isSupersetEnabled;
  var _useState = useState(needs.map(function () {
      var need = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return {
        id: need.service_type && need.service_type.id,
        name: need.service_type && need.service_type.name,
        value: initiallyChecked
      };
    })),
    _useState2 = _slicedToArray(_useState, 2),
    needChecks = _useState2[0],
    setNeedChecks = _useState2[1];
  var onChange = function onChange(id) {
    return function () {
      var index = needChecks.findIndex(function (needCheck) {
        return needCheck.id === id;
      });
      // Set the new needs by replacing element at index.
      setNeedChecks([].concat(_toConsumableArray(needChecks.slice(0, index)), [_objectSpread(_objectSpread({}, needChecks[index]), {}, {
        value: !needChecks[index].value
      })], _toConsumableArray(needChecks.slice(index + 1))));
    };
  };
  var handleSubmit = function handleSubmit() {
    var checkedNeeds = needChecks.filter(function (_ref2) {
      var value = _ref2.value;
      return Boolean(value);
    });
    var originalCheckedNeeds = needs.filter(function (need) {
      return checkedNeeds.some(function (_ref3) {
        var id = _ref3.id;
        return need.service_type.id === id;
      });
    });
    onSubmit(originalCheckedNeeds);
  };
  return /*#__PURE__*/React.createElement(BaseCard, {
    className: "screening-need-selector"
  }, /*#__PURE__*/React.createElement(BaseCardHeader, {
    title: isSupersetEnabled ? 'Suggested Service Types' : 'Suggested Referrals'
  }), /*#__PURE__*/React.createElement(BaseCardBody, {
    className: "screening-need-selector__body"
  }, !isSupersetEnabled && /*#__PURE__*/React.createElement("p", null, "This client has been determined", ' ', isHighRisk && /*#__PURE__*/React.createElement("span", {
    "data-testid": "high-risk-fragment"
  }, "to be ", /*#__PURE__*/React.createElement("strong", null, "high risk"), " and", ' '), "to have the following needs. Selected service types will be added to a referral:"), isSupersetEnabled && /*#__PURE__*/React.createElement("p", null, "The results of this screening suggest that this client", ' ', isHighRisk && /*#__PURE__*/React.createElement("span", {
    "data-testid": "high-risk-fragment"
  }, "is ", /*#__PURE__*/React.createElement("strong", null, "high risk"), " and", ' '), "might need support with the following service types. Select the ones you want to use to find relevant resources."), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '1rem'
    }
  }), /*#__PURE__*/React.createElement("form", null, needChecks.map(function (_ref4) {
    var name = _ref4.name,
      id = _ref4.id,
      value = _ref4.value;
    return /*#__PURE__*/React.createElement(CheckBoxField, {
      key: id,
      id: id,
      label: name,
      onChange: onChange(id),
      value: value
    });
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '1rem'
    }
  }), /*#__PURE__*/React.createElement(Button, {
    disabled: needChecks.filter(function (_ref5) {
      var value = _ref5.value;
      return Boolean(value);
    }).length === 0,
    fullWidth: true,
    id: "screening-need-selector-submit-button",
    label: isSupersetEnabled ? 'Find Resources' : 'Create Referrals',
    onClick: handleSubmit,
    primary: true
  }))));
}
ScreeningNeedSelector.propTypes = {
  initiallyChecked: PropTypes.bool,
  needs: PropTypes.array,
  onSubmit: PropTypes.func,
  isHighRisk: PropTypes.bool,
  isSupersetEnabled: PropTypes.bool
};
ScreeningNeedSelector.defaultProps = {
  initiallyChecked: false,
  needs: [],
  onSubmit: function onSubmit() {},
  isHighRisk: false,
  isSupersetEnabled: false
};
export default ScreeningNeedSelector;